import DeleteVendorContactContainer from "./DeleteVendorContactContainer";
export default DeleteVendorContactContainer;
